// @flow
import type { TypeaheadScope } from './types';

/**
 * A utility to extract the typeahead scope parameters from an untyped non-Lithium route. This
 * mimics the current geopill/typeahead behavior that always uses the current scoped page, but
 * users of this package may wish to explicitly specify a scope in another way or use strongly
 * typed Lithium URL args.
 */
const getTypeaheadScopeFromRoute = (route: { [string]: string }): TypeaheadScope => {
  if (route.isNearby && route.latitude && route.longitude) {
    return {
      latitude: parseFloat(route.latitude),
      longitude: parseFloat(route.longitude),
    };
  }

  if (route.geo != null && parseInt(route.geo, 10) > 1) {
    return {
      geoId: parseInt(route.geo, 10),
    };
  }

  return Object.freeze({});
};

export default getTypeaheadScopeFromRoute;
